import React from 'react';
import { RiLogoutCircleLine } from 'react-icons/ri';
import { logout } from 'src/utils/common';

const Logout = () => {
  return (
    <div className="w-fit-content text-white ml-3 mb-3 pb-2 fixed-bottom">
      <span onClick={logout} className="c-pointer">
        <span className="mr-2">
          <RiLogoutCircleLine />
        </span>
        Logout
      </span>
    </div>
  );
};

export default Logout;
